export const icons = {
	products: '/assets/images/report/products-icon.svg',
	performence: '/assets/images/report/performence-icon.svg',
	customers: '/assets/images/report/customers-icon.svg',
	certificates: '/assets/images/report/certificates-icon.svg',
} as const;
